import React from "react";
import { string } from "prop-types";

const TikTokIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="29"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M18.923 0c.5 4.115 2.902 6.569 7.077 6.83v4.628c-2.42.226-4.539-.53-7.004-1.957v8.656c0 10.998-12.534 14.434-17.573 6.552-3.238-5.072-1.256-13.973 9.132-14.33v4.881c-.791.122-1.637.313-2.41.566-2.31.748-3.62 2.149-3.257 4.62.7 4.733 9.778 6.133 9.024-3.115V.009h5.011V0Z"
      fill="#1876DB"
      fillRule="evenodd"
    />
  </svg>
);

TikTokIcon.propTypes = {
  className: string
};

TikTokIcon.defaultProps = {
  className: ""
};

export default TikTokIcon;
